export enum BrandingTemplate {
  companyName = '%CompanyName%',
  supportEmail = '%SupportEmail%',
}
